module.exports = __webpack_public_path__ + "img/logo-black.949de095.png";